import React from 'react';
import { MessageCircle, Radio, ShieldCheck, Clock, Shield, Truck } from 'lucide-react';
import { mockDifferentials } from '../mock';

const iconMap = {
  'message-circle': MessageCircle,
  'radio': Radio,
  'shield-check': ShieldCheck,
  'clock': Clock,
  'shield': Shield,
  'truck': Truck
};

export const DifferentialsSection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-[#0A2540] to-[#8B3A9C] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            Por que escolher a VIBE LOG?
          </h2>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto">
            Diferenciais que fazem toda a diferença no seu transporte
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {mockDifferentials.map((differential, index) => {
            const IconComponent = iconMap[differential.icon];
            return (
              <div 
                key={differential.id}
                className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 hover:bg-white/20 transition-all duration-300 border border-white/20"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="w-14 h-14 bg-[#F4D03F] rounded-xl flex items-center justify-center mb-4">
                  <IconComponent className="text-[#0A2540]" size={28} />
                </div>
                <h3 className="text-xl font-bold mb-2">{differential.title}</h3>
                <p className="text-gray-200">{differential.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
